export const ProfileEvents = {
    PROFILE_EDIT: "Profile - Edit Profile",
    PROFILE_FEEDBACK: "Profile - Share Your Feedback",
    PROFILE_SIGN_OUT: "Profile - Sign Out",
};